import React from "react";

export const Failed = () => {
    return (<div></div>);
}